import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import { updateQueryString } from 'services/router/actions';

// Components
import EntityTypesExistGate from 'components/EntityTypesExistGate';
import FormEntityDropdown from 'components/FormEntityDropdown';

// Selectors
import { makeSelectEntityTypeFirstDepthValue } from 'services/entityTypes/selectors';

interface Props {
    id: number;
    resetOnNewGroupCreation?: boolean;
}

export class GroupDropdownFilterDropdown extends React.PureComponent<Props> {
    render() {
        const { id, resetOnNewGroupCreation } = this.props;
        return (
            <EntityTypesExistGate>
                <FormEntityDropdown
                    entityTypeId={id}
                    resetOnNewGroupCreation={resetOnNewGroupCreation}
                />
            </EntityTypesExistGate>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    id: makeSelectEntityTypeFirstDepthValue('id')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(GroupDropdownFilterDropdown);
